<template>
  <div style="display: inline-flex;">
    <period-control v-model="periodId" @change="periodChange"> </period-control>
    <kendo-dropdownlist
      :data-source="fromPeriodDataSource"
      :data-text-field="'periodCode'"
      :data-value-field="'toDate'"
      @databound="fromPeriodDataBound"
      @change="fromPeriodChange"
      :autoBind="false"
      style="width: 110px;"
    >
    </kendo-dropdownlist>
    <kendo-dropdownlist
      :data-source="toPeriodDataSource"
      :data-text-field="'periodCode'"
      :data-value-field="'toDate'"
      @databound="toPeriodDataBound"
      @change="toPeriodChange"
      :autoBind="false"
      style="width: 110px;"
    >
    </kendo-dropdownlist>
    <kendo-dropdownlist
      :data-source="divisionDataSource"
      :data-text-field="'divisionName'"
      :data-value-field="'divisionId'"
      @databound="divisionDataBound"
      @change="divisionChange"
      :autoBind="false"
      style="width: 130px;"
    >
    </kendo-dropdownlist>
    <kendo-dropdownlist
      :data-source="ccyPairDataSource"
      :data-text-field="'pairCode'"
      :data-value-field="'ccyPairId'"
      @databound="ccyPairDataBound"
      @change="ccyPairChange"
      :autoBind="false"
      style="width: 110px;"
    >
    </kendo-dropdownlist>
    <label>
      Quarter:
      <input type="checkbox" v-model="quarterView" @change="quarterViewChange" />
    </label>
    <label>
      Historical:
      <input type="checkbox" v-model="historical" @change="historicalChange" />
    </label>
  </div>
</template>
<script>
import PeriodControl from '@/components/PeriodControl'
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  components: {
    PeriodControl,
  },
  data() {
    return {
      periodId: -1,
      asOfDate: null,
      divisionId: -1,
      ccyPairId: -1,
      toDate: null,
      fromDate: null,
      quarterView: true,
      historical: false,
      fromPeriodDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/ExposureToolbar/getFromPeriods',
            contentType: 'application/json',
            data: () => ({
              clientId: this.clientId,
              periodId: this.periodId,
              divisionId: this.divisionId,
              ccyPairId: this.ccyPairId,
              historical: this.historical,
            }),
            type: 'GET',
          },
        },
      }),
      toPeriodDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/ExposureToolbar/getToPeriods',
            contentType: 'application/json',
            data: () => ({
              clientId: this.clientId,
              periodId: this.periodId,
              divisionId: this.divisionId,
              ccyPairId: this.ccyPairId,
              fromDate: this.fromDate,
            }),
            type: 'GET',
          },
        },
      }),
      divisionDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/ExposureToolbar/getUserDivisions',
            contentType: 'application/json',
            data: () => ({
              clientId: this.clientId,
            }),
            type: 'GET',
          },
        },
      }),
      ccyPairDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/ExposureToolbar/getCcyPairs',
            contentType: 'application/json',
            data: () => ({
              clientId: this.clientId,
              divisionId: this.divisionId,
            }),
            type: 'GET',
          },
        },
      }),
    }
  },
  methods: {
    toolbarChange() {
      const selectedValues = {
        clientId: this.clientId,
        periodId: this.periodId,
        divisionId: +this.divisionId,
        ccyPairId: +this.ccyPairId,
        asOfDate: this.asOfDate,
        fromDate: this.fromDate,
        toDate: this.toDate,
        quarterView: this.quarterView,
        historical: this.historical,
      }
      this.$emit('change', selectedValues)
    },
    periodChange(e) {
      this.asOfDate = e.endDate
      this.divisionDataSource.read()
    },
    quarterViewChange() {
      this.toolbarChange()
    },
    historicalChange() {
      this.fromPeriodDataSource.read()
    },
    fromPeriodDataBound(e) {
      e.sender.select(0)
      this.fromDate = e.sender.value()
      e.sender.trigger('change')
    },
    fromPeriodChange(e) {
      this.fromDate = e.sender.value()
      this.toPeriodDataSource.read()
    },
    toPeriodDataBound(e) {
      e.sender.select(0)
      this.toDate = e.sender.value()
      e.sender.trigger('change')
    },
    toPeriodChange(e) {
      this.toDate = e.sender.value()
      this.toolbarChange()
    },
    divisionDataBound(e) {
      e.sender.select(0)
      this.divisionId = e.sender.value()
      e.sender.trigger('change')
    },
    divisionChange(e) {
      this.divisionId = e.sender.value()
      this.ccyPairDataSource.read()
    },
    ccyPairDataBound(e) {
      e.sender.select(0)
      this.ccyPairId = e.sender.value()
      e.sender.trigger('change')
    },
    ccyPairChange(e) {
      this.ccyPairId = e.sender.value()
      this.fromPeriodDataSource.read()
    },
  },
}
</script>
